import type { TDatadogErrorLog } from 'utils/datadog/types'

export const LOAD_DASHBOARD_FOLDERS_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/dashboard-folder-list',
  name: 'Loads Dashboard Folders',
  message: 'Failed to load the Dashboard Folders list',
}

export const BASE_PAGE_SIZE = 8
export const EDITOR_INITIAL_PAGE = 7
